export default __webpack_public_path__ + "static/media/strasbourg8.cefffcb9.jpg";